module.exports = __webpack_public_path__ + "img/vector.62254387.png";